import React, { useState } from 'react';
import { YearSeasonFilter } from '../../../Shared/Filters/YearSeasonFilter/YearSeasonFilter';
import * as DateFns from 'date-fns';

import RadioPracticesGames from '../RadioPracticesGames';
import { fileDownload, getFile, getTeamProps, isCC, isNCAA, isNCAAAllSports, paramBuilder } from '../../../../helpers';
import { FILTER_KEYS, LEAGUES, ON_EXPORT_ALERT } from '../../../../config/constants';
import { useFiltersState, useUserState } from '../../../../store/hooks';
import { MetaDataPlayer } from '../../../../store/types';
import { TeamProps } from '../../types';
import { useRouter } from 'helpers/customHooks';
import { Dropdown } from 'react-bootstrap';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { message, notification } from 'antd';
import { SERVER } from 'config/server.config';
// import Index from '../../../Shared/Filters/Index/DateRangeSelectorContainer';
// import {INTENSITY} from "../../../../config/constants";
// import SimpleMultiSelector from "../../../Shared/Filters/SimpleMultiSelectorContainer";

export default ({ player }: { player: MetaDataPlayer }) => {
  
  const user = useUserState();
  const [showFilter, setShowFilter] = useState(-1);
  const { specificScope} = useRouter();
  
  const close = () => setShowFilter(-1);
  const teamData = getTeamProps(player.teamId) as TeamProps | null;
  const {
    [FILTER_KEYS.DATE_RANGE]: year
  } = useFiltersState(specificScope, FILTER_KEYS.DATE_RANGE);
  const defaultYear = year?.year;
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
  const notificationKey = 'downloadFinished';
  const notificationDownload = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download In Progress',
      description:
        `Your file ${name} is being processed.`,
      duration: 0,
      icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadFinish = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download Finished',
      description: `Your file ${name} has been downloaded successfully.`,
      duration: 4,
      icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadError = (name:string) => {
    const args = {
      key: notificationKey,
      message: `Error downloading file ${name}`,
      duration: 4,
      icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
    };
    notification.open(args);
  };



  const exportBulkCSV = async (customer: string, player: string, bulkDataType: string) => {
    const playerScopeData = year;
    if (!!playerScopeData) {
      fileIsDownloading(true);
      notificationDownload(`${player}_bulk.csv`);
      const yearSelected = defaultYear as number;
      const compareRange = `${DateFns.format(new Date(yearSelected, 2, 1), 'yyyyMMdd')}-${DateFns.format(DateFns.subDays(new Date(yearSelected + 1, 2, 1), 1), 'yyyyMMdd')}`;
      const params: { tzOffset?: number } = {};
      const localDate = new Date();
      params['tzOffset'] = -localDate.getTimezoneOffset();
      const materialize = 'no';
      const sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      };
      let done;    
        do{
          done = await fileDownload (SERVER.CSV_REPORT_BULKDATA(customer, player, bulkDataType, compareRange) + '&' + paramBuilder(params) + `&materialize=${materialize}`);
          if(done === 0){
            await sleep(10);
          }else{
            await sleep(5000);
          } 
        }while(done === 1);
      if (done === 0) {
        const materialize = 'yes';
        await getFile (SERVER.CSV_REPORT_BULKDATA(customer, player, bulkDataType, compareRange) + '&' + paramBuilder(params) + `&materialize=${materialize}`, `${player}_bulk.csv`);
        fileIsDownloading(false);
        notificationDownloadFinish(`${player}_bulk.csv`);
      } else {
        fileIsDownloading(false);
        notificationDownloadError(`${player}_bulk.csv`);
      }
    } else {
      fileIsDownloading(false);
      message.warning({
        content: ON_EXPORT_ALERT,
        className: 'antd-message-alert'
      });
    }
  };
  return (
    <div className="head-filters-01">
      <YearSeasonFilter
        urlPersistent
        show={showFilter === 4}
        close={close}
        open={() => setShowFilter(4)}
        defaultYear={defaultYear ? Number(defaultYear) : undefined}
        isNcaa={isNCAAAllSports(user) || isNCAA(user) || (isCC(user) && (teamData!.league === LEAGUES.MLAX || teamData!.league === LEAGUES.NCAA))}
      />
      {/*<Index*/}
      {/*  show={showFilter === 0} close={close} open={() => setShowFilter(0)}*/}
      {/*  loadData={() => getPlayerMetrics()} playerId={player.nid}*/}
      {/*// playerId is not used*/}
      {/*/>*/}
      {/* <SimpleMultiSelector type={INTENSITY}
       show={showFilter===1} close={()=>setShowFilter(-1)} open={()=>setShowFilter(1)}
       loadData={()=> getPlayerMetrics()} playerId={playerId}/> */}
      <RadioPracticesGames player={player} />
      <div style={{marginTop: '6px'}}
              className='player-page-bulk-export'>
              <Dropdown
                className="player-customer-export-button"
              >
                <Dropdown.Toggle id="dropdown-basic" className="btn-blue" >
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => exportBulkCSV(player.teamId as string, player.playerId as string, 'practices')} target={'_blank'}>
                    Practice Data Only
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportBulkCSV(player.teamId as string, player.playerId, 'games')} target={'_blank'}>
                    Game Data Only
                  </Dropdown.Item>
                  <Dropdown.Item
                   onClick={() => exportBulkCSV(player.teamId as string, player.playerId, 'practices,games')}
                    target={'_blank'}
                  >
                    Practice/Game Combined
                  </Dropdown.Item>
                  {
                    (player.position === 'QB' || player.position === 'K' || player.position === 'P' || player.position === 'LS') && (
                  <>
                  <Dropdown.Item onClick={() => exportBulkCSV(player.teamId as string, player.playerId, 'practiceBallFlights')} target={'_blank'}>
                    Practice Ball
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportBulkCSV(player.teamId as string, player.playerId, 'gameBallFlights')} target={'_blank'}>
                    Game Ball
                  </Dropdown.Item>
                  </>
                    )
                  }
                </Dropdown.Menu>
              </Dropdown>
              </div>
    </div>
  );
};
